import httpService from '@/app/arch/services/HttpService';
import CrudRequest from 'Arch/components/crud/CrudRequest';

class TemplatesRequest extends CrudRequest {
  static baseUrl() {
    return '/communication/templates';
  }

  static terminate(templateType = '') {
    return httpService.get(
      '/contacardcommon/receipts/template',
      {
        params: {
          templateType,
        },
        responseType: 'blob',
      },
    );
  }
}

export default TemplatesRequest;
